const { ref, watch } = Vue

// Suponho que GLOBAL.isFundacao seja usado em outro lugar, mantendo aqui para referência
const { isFundacao } = GLOBAL

// Variável global para o debounce
window.timingSearchFundacao = null

export default {
	emits: ['click:item', 'update:searchQuery'],

	props: {
		searchQuery: {
			type: String,
			default: '',
		},
	},

	setup(props, ctx) {
		const inputValue = ref(props.searchQuery)

		watch(
			() => props.searchQuery,
			(novaQuery) => {
				if (novaQuery !== inputValue.value) {
					inputValue.value = novaQuery
				}
			}
		)
		watch(inputValue, (val) => {
			ctx.emit('update:searchQuery', val)
		})

		function debounceFunction(fn, wait = 300) {
			return (...args) => {
				clearTimeout(window.timingSearchFundacao)
				window.timingSearchFundacao = setTimeout(() => fn(...args), wait)
			}
		}

		function search(e) {
			/* console.log('Buscando por:', inputValue.value) */
		}

		return {
			inputValue,
			debounceFunction,
			search,
		}
	},

	template: html`
		<div class="input-icon relative">
			<q-input
				v-model="inputValue"
				outlined
				debounce="1000"
				class="h-48 w-[20.88rem]"
				placeholder="Pesquise.."
				js-ativo
				type="text"
				@keydown="(e) => debounceFunction(search, 800)(e)" />

			<svg
				v-if="inputValue"
				class="!w-32 !h-32 cursor-pointer"
				style="--cor-1: rgba(109,111,113,1);"
				@click="inputValue = ''">
				<use xlink:href="#icon_close"></use>
			</svg>
			<svg v-else>
				<use xlink:href="#icon_search"></use>
			</svg>
		</div>
	`,
}
